import type { ToastHandler } from '@cogo/runtime-v2'

import { useToastStore, type Toast } from '@/store/toast-store'

const MIN_RUNTIME_TOAST_MS = 1_000
const MAX_RUNTIME_TOAST_MS = 10_000

function runtimeToastType(variant: string | undefined): Toast['type'] {
  const normalized = variant?.trim().toLowerCase()
  if (normalized === 'success') return 'success'
  if (normalized === 'warning' || normalized === 'warn') return 'warning'
  if (
    normalized === 'error' ||
    normalized === 'destructive' ||
    normalized === 'danger'
  ) {
    return 'error'
  }
  return 'info'
}

function runtimeToastDuration(durationMs: number | undefined): number | undefined {
  if (!Number.isFinite(durationMs)) return undefined
  return Math.min(
    MAX_RUNTIME_TOAST_MS,
    Math.max(MIN_RUNTIME_TOAST_MS, Math.round(durationMs as number)),
  )
}

/** User-visible Studio sink for generated-app `showToast` ActionFlow steps. */
export const showStudioRuntimeToast: ToastHandler = ({
  message,
  description,
  variant,
  durationMs,
}) => {
  const title = message.trim()
  const detail = description?.trim()
  const duration = runtimeToastDuration(durationMs)
  useToastStore.getState().addToast({
    message: detail ? `${title} — ${detail}` : title,
    type: runtimeToastType(variant),
    ...(duration !== undefined ? { duration } : {}),
  })
}
